import PropTypes from 'prop-types';
import {Switch, Redirect, Route, useLocation} from 'react-router-dom';

import DiscoverBdrBox from '../DiscoverBdrBox';
import SentInvitations from '../SentInvitations';
import SuggestedRelationships from '../SuggestedRelationships';

import Message from './message';
import {useClientsStore} from './ClientsStore';
import Header from './header';
import ReceivedInvitations from './ReceivedInvitations';
import Tabs from './tabs';
import ClientsList from './clientsList';

function ClientsView({plan}) {
  const {state: {depositor, sentInvitations}, dispatch} = useClientsStore();
  const location = useLocation();

  return (depositor.loading || plan.loading) ?
    <div className="loading-overlay"/> :
    <>
      <Message plan={plan}/>

      <Header/>

      <DiscoverBdrBox/>

      <ReceivedInvitations/>

      <SuggestedRelationships/>

      <Tabs/>

      <div className="mb-5">
        <Switch>
          <Redirect
            from="/clients/invitations-received"
            to="/clients/list"
          />
          <Redirect
            data-id="redirect-accept-relationship"
            from="/clients"
            exact
            to={`/clients/list${location.search}`}
          />
          <Route
            exact
            path="/clients/list"
            component={ClientsList}
          />
          <Route
            exact
            path="/clients/invitations-sent"
            render={() => (
              <SentInvitations
                error={sentInvitations.error}
                loading={sentInvitations.loading}
                sentInvitations={sentInvitations.list}
                onRefreshRequested={() => dispatch({type: 'FETCH_DATA'})}
              />
            )}
          />
        </Switch>
      </div>
    </>;
}

ClientsView.propTypes = {
  plan: PropTypes.shape({
    loading: PropTypes.bool,
    depositorServiceAuthorized: PropTypes.bool,
    upgradable: PropTypes.bool
  }).isRequired
};

export default ClientsView;
